import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useTableSort from '@/hooks/table/use-table-sort.hook'

import { TableHeadCellPropsType } from '@/state/ui/global/models'
import { SportsROBetDetailsType } from '@/state/sports-ro-calculator/models'
import { ApplicationState } from '@/state/root.models'

type Props = {
  id?: string
}

export const useSportsBetDetails = ({ id }: Props) => {
  const { t } = useTranslation()

  const { sportsRO } = useSelector(({ sportsRO }: ApplicationState) => sportsRO)

  const headCells: TableHeadCellPropsType<SportsROBetDetailsType>[] = [
    { id: 'leagueDescription', label: t('transaction.league') },
    { id: 'productDescription', label: t('transaction.product') },
    { id: 'sportId', label: t('transaction.sportId') },
    { id: 'sportDescription', label: t('transaction.sport') },
    { id: 'gameDescription', label: t('transaction.game') },
    { id: 'pickLine', label: t('transaction.pickLine') },
  ]

  const betDetails = id
    ? sportsRO.transactions.find((sportRO) => sportRO.betId === id).betDetails
    : []

  const formattedBetDetails =
    betDetails?.map((wallet: SportsROBetDetailsType) => {
      return {
        ...wallet,
      }
    }) || []

  const sortedInitialState = 'gameId'

  const { sortedRows, createSortHandler, order, orderBy } = useTableSort<
    SportsROBetDetailsType,
    keyof SportsROBetDetailsType
  >(formattedBetDetails, sortedInitialState, 'desc')

  return {
    sortedRows,
    createSortHandler,
    order,
    orderBy,
    headCells,
  }
}
